/* EVENTS */
export const GET_MAYBANK_APPOINTMENTS = "GET_MAYBANK_APPOINTMENTS"
export const GET_MAYBANK_APPOINTMENTS_SUCCESS = "GET_MAYBANK_APPOINTMENTS_SUCCESS"
export const GET_MAYBANK_APPOINTMENTS_FAIL = "GET_MAYBANK_APPOINTMENTS_FAIL"

export const GET_MAYBANK_APPOINTMENTS_DETAILS = "GET_MAYBANK_APPOINTMENTS_DETAILS"
export const GET_MAYBANK_APPOINTMENTS_DETAILS_SUCCESS = "GET_MAYBANK_APPOINTMENTS_DETAILS_SUCCESS"
export const GET_MAYBANK_APPOINTMENTS_DETAILS_FAIL = "GET_MAYBANK_APPOINTMENTS_DETAILS_FAIL"

export const ADD_NEW_MAYBANK_APPOINTMENTS = "ADD_NEW_MAYBANK_APPOINTMENTS"
export const ADD_MAYBANK_APPOINTMENTS_SUCCESS = "ADD_MAYBANK_APPOINTMENTS_SUCCESS"
export const ADD_MAYBANK_APPOINTMENTS_FAIL = "ADD_MAYBANK_APPOINTMENTS_FAIL"

export const UPDATE_MAYBANK_APPOINTMENTS = "UPDATE_MAYBANK_APPOINTMENTS"
export const UPDATE_MAYBANK_APPOINTMENTS_SUCCESS = "UPDATE_MAYBANK_APPOINTMENTS_SUCCESS"
export const UPDATE_MAYBANK_APPOINTMENTS_FAIL = "UPDATE_MAYBANK_APPOINTMENTS_FAIL"

export const DELETE_MAYBANK_APPOINTMENTS = "DELETE_MAYBANK_APPOINTMENTS"
export const DELETE_MAYBANK_APPOINTMENTS_SUCCESS = "DELETE_MAYBANK_APPOINTMENTS_SUCCESS"
export const DELETE_MAYBANK_APPOINTMENTS_FAIL = "DELETE_MAYBANK_APPOINTMENTS_FAIL"

export const CONFIRM_MAYBANK_APPOINTMENTS = "CONFIRM_MAYBANK_APPOINTMENTS"
export const CONFIRM_MAYBANK_APPOINTMENTS_SUCCESS = "CONFIRM_MAYBANK_APPOINTMENTS_SUCCESS"
export const CONFIRM_MAYBANK_APPOINTMENTS_FAIL = "CONFIRM_MAYBANK_APPOINTMENTS_FAIL"

export const ADD_REMARKS_PRE_APPOINTMENTS = "ADD_REMARKS_PRE_APPOINTMENTS"
export const ADD_REMARKS_PRE_APPOINTMENTS_SUCCESS = "ADD_REMARKS_PRE_APPOINTMENTS_SUCCESS"
export const ADD_REMARKS_PRE_APPOINTMENTS_FAIL = "ADD_REMARKS_PRE_APPOINTMENTS_FAIL"

export const RESET_MAYBANK_APPOINTMENTS_STATE = 'RESET_MAYBANK_APPOINTMENTS_STATE';
